import React from "react";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Link } from "react-router-dom";

const AsideMenuItem = ({
  href,
  iconClass,
  title,
  children,
  toggleId,
  isActive,
  isOpen,
  onToggle,
}) => {
  return (
    <div className={`menu-item py-2 ${isActive ? "active-tab" : ""}`}>
      {children ? (
        <>
          <a
            onClick={onToggle}
            className={`accordion-button menu-link menu-center ${
              isOpen ? "" : "collapsed"
            }`}
            aria-expanded={isOpen}
          >
            <div className="accordion-item">
              <span className="menu-icon mx-auto">
                <i className={iconClass}></i>
              </span>
              <span className="menu-title">{title}</span>
            </div>
          </a>
          <div
            id={toggleId}
            className={`accordion-collapse mt-3 ${isOpen ? "show" : "collapse"}`}
            aria-labelledby={toggleId}
          >
            <div className="accordion-body">{children}</div>
          </div>
        </>
      ) : (
        <Link to={href} className="menu-link menu-center">
          <div className="menu-item-column">
            <span className="menu-icon mx-auto">
              <i className={iconClass}></i>
            </span>
            <span className="menu-title">{title}</span>
          </div>
        </Link>
      )}
    </div>
  );
};

export default AsideMenuItem;
